import { Flex, Table, Tbody, Th, Thead, Tr } from "@chakra-ui/react";
import { CompraSericoTypeItem } from "models/compras_type";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ProductType } from "models/product_type";
import useMeasureUnit from "views/admin/order/measureUnit/hooks/useMeasureUnit";
import AddRowServico from "./AddRowServico";
import ItemRowServico from "./ItemRowServico";

interface  IItemServicoTable {
    borderColor: string;
    itemList: CompraSericoTypeItem[];
    addRowService : (item : CompraSericoTypeItem) => void;
    editRowService : (item : CompraSericoTypeItem) => void;
    deleteRowService : (item : CompraSericoTypeItem) => void;
    condicaoPagamento: CondicaoPagamento[] | undefined;
    showError: (title: string, msg: string) => void;
    produtos : ProductType[];
}

const ItemServicoTable = ({addRowService, borderColor, deleteRowService, editRowService, itemList, condicaoPagamento, produtos, showError} : IItemServicoTable) => {
    
  const { unidades } = useMeasureUnit();
  
  return (
    
        <Table
        variant="striped"
        color="gray.500"
        mb="24px"
        mt="12px"
        key={`servico-table`}
      >
        <Thead>
          <Tr>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #
              </Flex>
            </Th>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #ITEM
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #DESCRICAO
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #UNIDADE
              </Flex>
            </Th>
            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #QTD
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #VALOR UN
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #TOTAL
              </Flex>
            </Th>

            <Th pe="10px" borderColor={borderColor} cursor="pointer">
              <Flex
                justifyContent="space-between"
                align="center"
                fontSize={{ sm: "10px", lg: "12px" }}
                color="gray.400"
              >
                #OPÇÕES
              </Flex>
            </Th>
          </Tr>
        </Thead>
        <Tbody>
            <AddRowServico
                addRowService={addRowService}
                produtos={produtos}
                showError={showError}
            />
            {
              itemList.map((item) => (
            <ItemRowServico
                deleteRow1={deleteRowService}
                editItem={editRowService}
                item1={item}
                produtos={produtos}
                unidades={unidades}
            />
              )
                
              )
            }
        </Tbody>
      </Table>
    
        );
}
export default ItemServicoTable;